/* London & Co. — plate behaviour (§12, §25, §36).
   Two jobs only:
   1. fade each image in on decode, so the plate never flashes a half-loaded image;
   2. fetch the SECOND image on hover intent rather than at page load — this
      roughly halves desktop grid image weight on a 48-product page.
   No framework, no animation library. Total footprint is a few hundred bytes. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markLoaded(img) {
    if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
    else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
  }

  function init(root) {
    (root || document).querySelectorAll('.lc-plate__img:not([data-src])').forEach(markLoaded);

    if (reduce) return;
    (root || document).querySelectorAll('.lc-plate-card[data-has-alt]').forEach(function (card) {
      if (card.dataset.altBound) return;
      card.dataset.altBound = '1';
      card.addEventListener('mouseenter', function () {
        var alt = card.querySelector('.lc-plate__img--alt[data-src]');
        if (!alt) return;
        alt.src = alt.dataset.src;
        if (alt.dataset.srcset) alt.srcset = alt.dataset.srcset;
        alt.removeAttribute('data-src');
        alt.removeAttribute('data-srcset');
        markLoaded(alt);
      }, { once: true });
    });
  }

  /* Re-bind after the grid is swapped in.

     `shopify:section:load` was the original hook here, and it never fired for a
     customer: Shopify only dispatches it inside the theme editor. On the live
     storefront facets.js replaces the innerHTML of #ProductGridContainer when a
     filter or sort changes, so every plate in the new grid was DOM that init()
     had never seen. lc-plate.css starts .lc-plate__img at opacity:0 and waits
     for .is-loaded, so those images downloaded, decoded, and then sat there
     invisible until a full page reload — measured as 36 of 36 plates with the
     image complete and naturalWidth > 0 but the class absent.

     A MutationObserver is used rather than a facets.js hook because nothing in
     that file publishes an event, and this also covers any other injected
     grid (load-more, quick-add, predictive search) without coupling to it.
     Work is only queued when the injected markup actually contains a plate,
     and coalesced to one init per tick. */
  function watchForInjectedPlates() {
    if (!('MutationObserver' in window)) return;
    var queued = false;
    /* setTimeout rather than requestAnimationFrame: rAF is frozen while a tab
       is backgrounded, which would leave a filtered grid un-initialised until
       the customer returned to the tab. All this work does is add a class, so
       there is nothing to gain from waiting for a paint frame. */
    var schedule = function (fn) { setTimeout(fn, 0); };

    new MutationObserver(function (mutations) {
      if (queued) return;
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          var isPlate = node.classList && node.classList.contains('lc-plate__img');
          if (isPlate || (node.querySelector && node.querySelector('.lc-plate__img'))) {
            queued = true;
            schedule(function () { queued = false; init(document); });
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    watchForInjectedPlates();
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.LCPlate = { init: init };
})();
